export default {
  training: {
    code: "Código",
    hours: "Número de horas",
    hours_learning: "Número de horas de enseñanza",
    public: "Público previsto",
    comment: "Comentario",
    registrants_number: "Número de inscritos",
    publish_success: "¡Referencia publicada con éxito!",
    publish_program_success: "¡Programa publicado con éxito!",
    rncp: {
      nsf_codes: "Códigos NSF",
      form_codes: "Formacódigos",
      rome_codes: "Códigos Rome",
      targeted_activities: "Actividades previstas",
      domains: "Dominios",
      industry_sector_and_types_job: "Sector de actividad y tipos de empleo",
      business_sectors: "Sectores de actividad",
      types_of_jobs: "Tipos de empleos",
      due_date: "Fecha de vencimiento",
      previous_certification: "Certificación anterior",
      new_certification: "Nueva certificación",
      editing_competency_framework: "Edición del marco de competencias",
      enable_critical_learnings: "Activar los aprendizajes críticos",
      critical_learning_update_success: "Preferencia de visualización de los aprendizajes críticos guardada",
      critical_learning_update_error: "Error al guardar la preferencia",
      rncp_skills: "competencias RNCP",
      missions: "misiones vinculadas",
      ai_suggestions: "sugerencias IA",
      skills_related: "Competencias vinculadas a este bloque de competencias",
      missions_related: "Misiones vinculadas a este bloque de competencias",
      ai_suggestions_related_skills: "Sugerencias IA - Competencias complementarias",
      ai_suggestions_related_missions: "Sugerencias IA - Misiones complementarias",
      relaunch_ai: "Relanzar (3 nuevas)",
      triad: "Cuaderno,",
      badge: {
        rome: "ROME",
        rncp: "RNCP",
        triad: "Cuaderno del alternante",
        job_offer: "ofertas de empleo",
        offer: "ofertas",
        sources: "Fuentes",
        triads: "Cuadernos",
        confidence: "Confianza",
      },
      workflow: {
        skill_import_label: "Importar competencias",
        enrichment_import_label: "Enriquecimiento IA",
        publish_import_label: "Publicación",
        waiting_status_label: "Por venir",
        pending_status_label: "En curso",
        finished_status_label: "Terminado",
        import_button_label: "Importar",
        enrichment_button_label: "Enriquecer las competencias",
        publish_button_label: "Publicar",
        enrichment_progress_title: "Importación en curso",
        enrichment_step_skills: "Importación de competencias",
        enrichment_step_skills_description:
          "Análisis de las competencias esperadas por el mercado laboral y no identificadas en el referencial",
        enrichment_step_critical_learnings: "Importación de aprendizajes críticos",
        enrichment_step_critical_learnings_description:
          "Propuestas argumentadas de lo que un aprendiz sabría hacer en cada nivel de competencia",
        enrichment_step_missions: "Importación de misiones",
        enrichment_step_missions_description:
          "Propuesta de tipos de misiones vinculadas al bloque de competencia (fuentes: ficha RNCP, referencial ROME y ofertas de empleo)",
        step_status_done: "terminado",
        step_status_pending: "en curso",
        step_status_error: "fallido",
        step_status_skipped: "no completada",
        enrichment_failed_title: "Importación fallida",
        enrichment_failed:
          "Una parte del análisis por IA ha fallado. Las partes correctas siguen mostrándose; puede volver a lanzar el análisis.",
      },
      actions: {
        reimporting_skills: "Datos existentes detectados",
      },
      modal: {
        text: "¿Cómo desea proceder con la nueva importación?",
        merge_button_title: "Fusionar",
        merge_button_text: "Conserva los datos existentes y añade únicamente los nuevos",
        crush_button_title: "Reemplazar",
        crush_button_text: "Elimina todos los datos existentes y los reemplaza por los nuevos",
        alert_title: "Ya existe una plantilla para esta formación",
        alert_text: "¿Cómo desea proceder con los nuevos datos?",
        submit: "Confirmar la importación",
      },
      alert: {
        empty_rncp_warning_text:
          "Para empezar a importar datos y crear su primer marco de competencias, debe indicar un título RNCP desde el formulario de configuración de la formación accesible únicamente por un administrador.",
        referential_publish_title: "Publicar un marco",
        referential_publish_sub_title: "¿Está seguro de que desea publicar este marco?",
        error: "Algo salió mal, por favor inténtelo de nuevo más tarde.",
        importing: "Datos en proceso de importación, por favor espere.",
        enriching: "Datos en proceso de enriquecimiento, por favor espere.",
        update_rncp: "Recuerde actualizar el código RNCP en cada nueva publicación",
        rncp_sheet_import:
          "Por favor proceda a la importación de competencias para mostrar los detalles del título RNCP de la formación.",
        rncp_skill_import:
          "Por favor proceda a la importación de competencias para empezar la configuración del marco de la formación.",
        due_date_in_month: "Vencimiento en {month} meses",
        due_date_in_day: "Vencimiento en {day} días",
        empty_skills: "No hay competencias por el momento",
        empty_missions: "No hay misiones por el momento",
        empty_suggestions: "No hay sugerencias, por favor relance la IA para obtener nuevas.",
        empty_block: "No hay bloque de competencias",
      },
      level: {
        niv3: "CAP/BEP (Nivel 3)",
        niv4: "BAC (Nivel 4)",
        niv5: "BAC+2 (Nivel 5)",
        niv7: "BAC+5 (Nivel 7)",
        niv8: "Doctorado (Nivel 8)",
      },
      source_detail: {
        criticality: {
          title: "Criticidad",
          low: "A vigila",
          medium: "Emergente",
          high: "Muy emergente",
        },
        pertinence: "Puntuación de relevancia",
        criteria: {
          title: "4 criterios seleccionados",
          pertinence_f: "Frecuencia en las ofertas",
          pertinence_a: "Alineación semántica",
          pertinence_p: "Proximidad al sector",
          pertinence_d: "Distinción",
        },
        justification: "Justificación IA",
        referential_presence: "Presencia en los repositorios",
        source: {
          rome: "ROME",
          esco: "ESCO",
          rncp: "RNCP",
          offres: "Ofertas de empleo",
          offre: "Oferta de empleo",
          livret: "Folleto",
          marche: "Mercado",
        },
        source_offers: "Ofertas de origen",
        published_at: "Publicado el",
        view_offer: "Ver la oferta",
        present: "Presente",
        absent: "Ausente",
        offers_count: "{jobOfferCount} ofertas de un total de {jobOfferTotal} analizadas mencionan esta {type}.",
      },
    },
    program: {
      import_failed: "La importación del programa no ha funcionado. Inténtelo de nuevo.",
      model: "Plantilla",
      required: "Obl/Opt",
      ects: "ECTS",
      coefficient_short: "Coef.",
      ai_confidence: "Confianza IA",
      target_audience: "Público objetivo",
      prerequisites: "Requisitos previos",
      training_targets: "Objetivos de la formación",
      informations: "Informaciones prácticas",
      general_informations: "Informaciones generales",
      graduation: "Diploma",
      route: "Recorrido",
      rncp_code: "Código RNCP",
      graduation_type: "Tipo de diploma",
      total_volume: "Volumen total",
      ects_credits: "Créditos ECTS",
      add_files: "Deposite sus archivos",
      training_program: "Programa de formación",
      duration: "Duración",
      modality: "Modalidad",
      pace: "Ritmo",
      location: "Lugar",
      professionalOutcomes: "Salidas profesionales",
      extension_accepted_message: "Solo se aceptan archivos PDF, DOC, DOCX, XLS, XLSX y MSWORD",
      steps: {
        import: {
          title: "Importación del programa",
          button: "Importar",
        },
        publish: {
          title: "Publicación del programa",
          button: "Publicar",
        },
        incoming: "Por venir",
        inprogress: "En curso",
        finished: "Terminado",
      },
      actions: {
        reimporting_program: "¿Reimportar el programa?",
      },
      modal: {
        text: "Ya existe un programa para esta formación. ¿Cómo desea proceder?",
        merge_button_title: "Conservar y completar",
        merge_button_text: "Los datos existentes se conservarán, los nuevos se añadirán.",
        crush_button_title: "Reemplazar completamente",
        crush_button_text: "Todos los datos existentes serán eliminados y reemplazados.",
        alert_title: "Importante",
        alert_text: "Esta acción impactará los próximos programas publicados y las formaciones asociadas.",
        submit: "Confirmar la importación",
        "general-info": "Modificar las informaciones generales",
        "target-audience": "Modificar el público objetivo y los requisitos previos",
        objectives: "Modificar los objetivos de la formación",
        "practical-info": "Modificar las informaciones prácticas",
      },
      training_period: {
        heading: {
          code: "Código",
          label: "Título",
          type: "Tipo",
          required: "Obl/Opt",
          hours: "Horas",
          ects: "ECTS",
          coef: "Coef.",
          actions: "Acciones",
        },
      },
      alert: {
        importing: "Datos en proceso de importación, por favor espere.",
        empty_semester:
          "No hay semestres por el momento, por favor añada uno\n" +
          "                  manualmente haciendo clic en el botón +",
        empty_unit:
          "No hay unidades ni módulos por el momento, por favor añada\n" +
          "                  manualmente haciendo clic en los botones +",
        program_import: "Por favor proceda a la importación del programa para empezar la configuración de la plantilla",
        file_uploaded_success: "Archivo importado con éxito | {count} archivos importados con éxito",
        file_upload_error: "Error al importar los archivos",
        note: "Nota",
        note_text:
          "Esta información ha sido extraída automáticamente de la plantilla PDF. Puede modificarla haciendo clic en el icono del lápiz.",
        warning_points: "Puntos de atención",
        warning_points_text: "3 módulos sin código • 2 módulos requieren verificación",
        empty_general_informations:
          "Por favor proceda a la importación del programa para mostrar las informaciones generales",
        unit_missing_code: ({ plural, named }) =>
          plural([`${named("count")} unidad sin código`, `${named("count")} unidades sin código`]),
        subject_missing_code: ({ plural, named }) =>
          plural([`${named("count")} módulo sin código`, `${named("count")} módulos sin código`]),
        unit_need_validation: ({ plural, named }) =>
          plural([
            `${named("count")} unidad requiere verificación`,
            `${named("count")} Las unidades requieren verificación.`,
          ]),
        subject_need_validation: ({ plural, named }) =>
          plural([
            `${named("count")} módulo requiere verificación.`,
            `${named("count")} módulos requieren verificación.`,
          ]),
        verification: "Datos por verificar",
        low_confidence_score:
          "La IA ha detectado este módulo con un nivel de confianza del {confidence} %. Comprueba y corrige la siguiente información antes de validarla.",
      },
    },
    matrix: {
      title: "Matriz UE / Competencia",
      enrich: "Reactivar el enriquecimiento",
      enriching: "Se está realizando el enriquecimiento de la matriz mediante IA; por favor, espere.",
      header: {
        title: "Competencias",
        block: ({ plural }) => plural(["bloque ", "bloques"]),
        skill: ({ plural }) => plural(["competencia ", "competencias"]),
      },
      tooltip: {
        total: "Correspondencia total",
        secondary: "Correspondencia secundaria",
        ai: "Sugerencia IA - {confidence} % de confianza",
      },
      tutorial: {
        title: "Guía de uso de la matriz",
        line_1_with_ai:
          "<strong>Haga clic en una celda</strong> para cambiar su estado: Sugerencia IA → Total → Secundaria → Ninguna → Total",
        line_1_without_ai:
          "<strong>Haga clic en una celda</strong> para cambiar su estado: Total → Secundaria → Ninguna → Total",
        line_2: "<strong>Active/desactive las sugerencias IA</strong> con el botón en la parte superior izquierda",
        line_3: "<strong>Despliegue los bloques y UE</strong> para ver/ocultar el detalle de competencias y módulos",
        line_4: "<strong>Las celdas verdes claras</strong> indican un vínculo indirecto en el nivel inferior",
        line_5: "<strong>Los badges naranja ⚠</strong> señalan los bloques/competencias sin correspondencia",
        line_6: "<strong>Las correspondencias modificadas se guardan automáticamente",
      },
      legend: {
        title: "Leyenda",
        total: "Correspondencia total",
        secondary: "Correspondencia secundaria",
        ai: "Sugerencia IA (por validar)",
      },
      suggestion: ({ plural }) => plural(["sugerencia", "sugerencias"]),
      mappings: ({ plural }) => plural(["correspondencia", "correspondencias"]),
      mapping: {
        success: "¡Correspondencia actualizada correctamente!",
        removed: "¡Correspondencia eliminada correctamente!",
        add: "¡Correspondencia añadida correctamente!",
      },
    },
    contact: {
      detail: {
        title: ({ named }) => `Detalle del contacto ${named("name")}`,
      },
    },
    contract_list: "Lista de contratos",
    contacts: {
      success: "¡Contactos guardados correctamente!",
    },
    go_to: {
      registration: "Ficha de preinscripción",
      contract: "Ficha de contrato",
    },
    space: "Espacio",
    plan_contract: {
      baseline: "Para seleccionar el año en el que está trabajando, haga clic en «activar»",
    },
    stats: {
      tab_title: "Estadísticas",
      export_all_excel: "Exportar todo (Excel)",
      export_all_csv: "Exportar todo (CSV)",
      export_csv: "Exportar a CSV",
      empty: "No hay estadísticas disponibles para esta formación.",
      calculation_note:
        "<strong>Cálculo de estadísticas</strong>: tasas calculadas sobre los cuestionarios publicados y no archivados." +
        " Un trío está completo cuando los 3 perfiles (alternante, tutor, responsable pedagógico) tienen acceso al cuaderno." +
        " Datos actualizados cada noche.",
      table: {
        promotion: "Promoción",
        questionnaires: "Cuestionarios",
        skills: "Competencias",
        connections: "Conexiones",
        triads: "Tríos",
        export: "Exportar",
      },
      profiles: {
        apprentice: "Alternante",
        tutor: "Tutor",
        apprentice_master: "Maestro de aprendizaje",
      },
      indicators: {
        questionnaire_fill_rate: "Tasa de cumplimentación de los cuestionarios",
        skill_fill_rate: "Tasa de cumplimentación de las competencias",
        user_connection_rate: "Tasa de conexión de los usuarios",
        completed_triads_rate: "Tasa de tríos completados",
      },
      subcounts: {
        promotions: "promoción(es)",
        active_users: "usuarios activos",
        triads: "trío(s)",
      },
    },
    sheet: "Ficha",
    dashboard: "Panel de control",
    company_contact: "Contactos de empresa",
  },
  employee: ({ plural }) => plural(["Empleado ", "Empleados"]),
};
